export const environment = {
  env: 'dev',
  production: true,
  legacy: {
    baseUrl: '',
  },
  back: {
    baseUrl: `https://pass.dev.bodytech.company/api`,
  },
  fariaLimaId: 34,
  sentry: {
    dsn: 'https://5e817bf5ea834ad390009869cee2c08e@sentry.dev.bodytech.company/2',
    enabled: true,
    environment: 'dev',
    release: 'btpass-360a879',
    attachStacktrace: true,
  },
};
